var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRedWhiteError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2812_834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16992 5C1.16992 6.06087 1.57235 7.07828 2.28867 7.82843C3.00498 8.57857 3.97652 9 4.98955 9C6.00258 9 6.97412 8.57857 7.69044 7.82843C8.40675 7.07828 8.80918 6.06087 8.80918 5C8.80918 3.93913 8.40675 2.92172 7.69044 2.17157C6.97412 1.42143 6.00258 1 4.98955 1C3.97652 1 3.00498 1.42143 2.28867 2.17157C1.57235 2.92172 1.16992 3.93913 1.16992 5Z",
    fill: "#E74343",
    stroke: "#E74343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59106 3.13732L4.98917 5.49984L5.38729 3.13732C5.42879 2.89102 5.23895 2.6665 4.98917 2.6665C4.7394 2.6665 4.54955 2.89102 4.59106 3.13732Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98917 8.1C5.31239 8.1 5.56663 7.82697 5.56663 7.5C5.56663 7.17303 5.31239 6.9 4.98917 6.9C4.66596 6.9 4.41172 7.17303 4.41172 7.5C4.41172 7.82697 4.66596 8.1 4.98917 8.1Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2812_834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.54907,
    height: 10,
    fill: "white",
    transform: "translate(0.214844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedWhiteError);
export default __webpack_public_path__ + "static/media/icon-red-white-error.b95c22aa49ab422ee1f061590a3c99be.svg";
export { ForwardRef as ReactComponent };